import { FC } from "react";
import AppModal from "../../../apps/components/AppModal";
import EvaluatorList from "../../../project/PanopticEvaluationSummary/EvaluatorList";
import { UserScore } from "../../../core/_models";

interface Props {
  show: boolean;
  onClose: () => void;
  projectId?: number,
  data: UserScore[]
  title?: string
}
const PanopticPrincipleModal: FC<Props> = ({
  show,
  onClose,
  data,
  title = "Panoptic Evaluation Individual Scores"
}) => {

  return (
    <AppModal
      show={show}
      title={title}
      width="800px"
      onClose={onClose}
      showCancelButton={false}
    >
      <EvaluatorList showProgress={true} scoreData={data} />
    </AppModal>
  );
};

export default PanopticPrincipleModal;